"use client";

import { usePathname } from "next/navigation";
import { marketingMotion } from "@/lib/motion/config";
import { SafeMotionDiv } from "@/components/ui/safe-animate-presence";

interface IMarketingPageTransitionProps {
  children: React.ReactNode;
}

/**
 * Marketing page transition: replays a subtle enter animation on each route
 * change (keyed by pathname). See SafeMotionDiv for why we avoid
 * AnimatePresence on React 19 + Turbopack.
 */
export function MarketingPageTransition({
  children,
}: IMarketingPageTransitionProps): React.ReactElement {
  const pathname = usePathname();

  return (
    <SafeMotionDiv
      motionKey={pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: marketingMotion.duration.base,
        ease: marketingMotion.easing.standard,
      }}
    >
      {children}
    </SafeMotionDiv>
  );
}
